import service from '@/utils/request'
import qs from 'qs'

export function login(_username, _password,_companyid) {
return service({
  url: '/token',
  method: 'post',
      baseURL: (process.env.BASE_API+'/').replace("/api/",""),
      data:qs.stringify({
        username: _username,
        password: _password,
        grant_type:'password',
        appcode:'VoionWebQuote',  /* SSO_App 表*/
        companyid:_companyid,
        version:'1.0',
      }),
})
// return service({
//   baseURL:'http://192.168.11.89:1646/api',
//   url: '/user/login',
//   method: 'post',
//   // headers: {  
//   //   "Access-Control-Allow-Origin":"*",
//   //   "Access-Control-Allow-Credentials":"false",
//   //   "Access-Control-Allow-Methods":"GET, POST, PATCH, PUT, OPTIONS",
//   //   "Access-Control-Allow-Headers":"Content-Type, Accept, Authorization, X-Requested-With, Origin, Accept",
//   // }, 
//   data:{
//     username: _username,
//     password: _password,
//   }
// })

}

export function getInfo(token) {
  return service({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return service({
    url: '/user/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js